import React, {useContext} from 'react';
import {Button, Layout, Modal, Space, Tooltip} from "antd";
import {Content} from "antd/es/layout/layout";
import {observer} from "mobx-react";
import {StoreContext} from "../../store.context";
import { WarningOutlined } from '@ant-design/icons';

const LockScreen: React.FC<any> = observer(() => {
    const {
        appStore: {
            authStore,
        },
    } = useContext(StoreContext);

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Modal
                    open={true}
                    footer={null}
                    closable={false}
                    centered
                >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                        <p>You have been inactive for 2 hours, You need to login to continue.</p>
                        <Space>
                            <Button type="primary" onClick={async () => {
                                await authStore.manualRefresh();
                            }}>Login</Button>

                            <Tooltip title="If You logout from BO, You will be logged out from MCL aswell!" placement="top">
                                <Button type="dashed" danger icon={<WarningOutlined />} onClick={async () => {
                                    await authStore.logout();
                                }}>Logout</Button>
                            </Tooltip>
                        </Space>
                    </div>
                </Modal>
            </Content>
        </Layout>
    )
})

export default LockScreen;